import $ from 'jQuery';


export default function() {

  $(function() {
    initialize_sidebarLinks();
  });


  function initialize_sidebarLinks() {
    const $sidebarLinks = $('.sidebar-link');
    const supportsIntersectionObserver = !!window.IntersectionObserver;


    if (supportsIntersectionObserver && $sidebarLinks.length) {
      let linkTargets = [];


      $sidebarLinks.each(function() {
        const $thisLink = $(this);
        const selectorURL = $thisLink.attr('href');

        if (selectorURL.startsWith('#')) {
          linkTargets.push(selectorURL);
        }
      });

      linkTargets = linkTargets.join(', ');
      const targetElements = document.querySelectorAll(linkTargets);


      let observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {

          if (entry.isIntersecting) {
            if (entry.intersectionRatio >= 0.7) {
              activateSidebarLink(entry.target);
            }
          }
        });
      }, {
        root: null,
        rootMargin: "0px",
        threshold: [0.7]
      });


      targetElements.forEach(observedEl => {
        observer.observe(observedEl);
      });


      function activateSidebarLink(targetEl) {
        const $target = $(targetEl);
        const targetIDSelector = '.sidebar-link[href="#' + $target.attr('id') + '"]';
        const $activeLink = $(targetIDSelector);

        $sidebarLinks
          .filter('.--active')
          .removeClass('--active');

        $activeLink.addClass('--active');
      }
    }

  }
}
